// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner_image {
  width: 100%;
  height: 460px;
}

.banner_text_div{
  position: absolute;
  top: 100px;
  width: 600px;
}
.banner_sub_text{

color: gray;
}

/* @media screen and (max-width: 1200px) {
  .banner_image {
      position: absolute;
      top: 8%;
      left: 8%;
      max-width: 290px;
      max-height: 180px;
    }
} */

/* On screens that are 1024px wide or less, the background color is blue */
/* @media screen and (max-width: 1024px) {
  .banner_image {
      position: absolute;
      top: 8%;
      left: 8%;
      max-width: 290px;
      max-height: 180px;
    }
} */
.site_width{
  width: 100%;
}
@media screen and (min-width: 2000px) {
  .banner_image {
      height: 550px;
    }

    .site_width{
      width: 65%;
    }
}

@media screen and (max-width: 1999px) {

    .site_width{
      width: 85%;
    }
}

@media screen and (min-width: 1919px) {
  .banner_image {
    width: 100%;
    height: 520px;
    }
}

@media screen and (max-width: 1360px) {

  .site_width{
    width: 100%;
  }
}

/* On screens that are 768px wide or less, the background color is olive */
@media screen and (max-width: 768px) {
  .banner_image {
      max-height: 260px;
    }

  .banner_text{
    font-size: 1.5rem;
      top: -30px !important;

  }
  .banner_text_div{
    top: 50px !important;
}
}

@media screen and (max-width: 480px) {
  .banner_image {
      max-height: 180px;
    }
  .banner_text{
      font-size: small;
      bottom: 25px !important;
  }
  
  /* .banner_text_div{
      top: 50px !important;
  } */
}
@media screen and (max-width: 423px) {
  
  .banner_text_div{
      top: -80px !important;
      left: -30px !important;
  }
}

/* On screens that are 480px wide or less, the background color is olive */
/* @media screen and (max-width: 480px) {
  .banner_image {
    background-color: olive;
    color: white;
  }
} */`, "",{"version":3,"sources":["webpack://./src/assets/Css/banner.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;AACA;;AAEA,WAAW;AACX;;AAEA;;;;;;;;GAQG;;AAEH,0EAA0E;AAC1E;;;;;;;;GAQG;AACH;EACE,WAAW;AACb;AACA;EACE;MACI,aAAa;IACf;;IAEA;MACE,UAAU;IACZ;AACJ;;AAEA;;IAEI;MACE,UAAU;IACZ;AACJ;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;;EAEE;IACE,WAAW;EACb;AACF;;AAEA,0EAA0E;AAC1E;EACE;MACI,iBAAiB;IACnB;;EAEF;IACE,iBAAiB;MACf,qBAAqB;;EAEzB;EACA;IACE,oBAAoB;AACxB;AACA;;AAEA;EACE;MACI,iBAAiB;IACnB;EACF;MACI,gBAAgB;MAChB,uBAAuB;EAC3B;;EAEA;;KAEG;AACL;AACA;;EAEE;MACI,qBAAqB;MACrB,sBAAsB;EAC1B;AACF;;AAEA,0EAA0E;AAC1E;;;;;GAKG","sourcesContent":[".banner_image {\n  width: 100%;\n  height: 460px;\n}\n\n.banner_text_div{\n  position: absolute;\n  top: 100px;\n  width: 600px;\n}\n.banner_sub_text{\n\ncolor: gray;\n}\n\n/* @media screen and (max-width: 1200px) {\n  .banner_image {\n      position: absolute;\n      top: 8%;\n      left: 8%;\n      max-width: 290px;\n      max-height: 180px;\n    }\n} */\n\n/* On screens that are 1024px wide or less, the background color is blue */\n/* @media screen and (max-width: 1024px) {\n  .banner_image {\n      position: absolute;\n      top: 8%;\n      left: 8%;\n      max-width: 290px;\n      max-height: 180px;\n    }\n} */\n.site_width{\n  width: 100%;\n}\n@media screen and (min-width: 2000px) {\n  .banner_image {\n      height: 550px;\n    }\n\n    .site_width{\n      width: 65%;\n    }\n}\n\n@media screen and (max-width: 1999px) {\n\n    .site_width{\n      width: 85%;\n    }\n}\n\n@media screen and (min-width: 1919px) {\n  .banner_image {\n    width: 100%;\n    height: 520px;\n    }\n}\n\n@media screen and (max-width: 1360px) {\n\n  .site_width{\n    width: 100%;\n  }\n}\n\n/* On screens that are 768px wide or less, the background color is olive */\n@media screen and (max-width: 768px) {\n  .banner_image {\n      max-height: 260px;\n    }\n\n  .banner_text{\n    font-size: 1.5rem;\n      top: -30px !important;\n\n  }\n  .banner_text_div{\n    top: 50px !important;\n}\n}\n\n@media screen and (max-width: 480px) {\n  .banner_image {\n      max-height: 180px;\n    }\n  .banner_text{\n      font-size: small;\n      bottom: 25px !important;\n  }\n  \n  /* .banner_text_div{\n      top: 50px !important;\n  } */\n}\n@media screen and (max-width: 423px) {\n  \n  .banner_text_div{\n      top: -80px !important;\n      left: -30px !important;\n  }\n}\n\n/* On screens that are 480px wide or less, the background color is olive */\n/* @media screen and (max-width: 480px) {\n  .banner_image {\n    background-color: olive;\n    color: white;\n  }\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
